export default __webpack_public_path__ + "static/media/jFrog-tool.57eca79b.png";